import api from "api/api";

export const getTemplateListQuery = async () =>
  await api.get(`/settings/eval_template`);
